module.exports = __webpack_public_path__ + "img/mob_product_04.3f64d0f2.png";